import {createRouter, createWebHistory} from 'vue-router'
import store from "@/store";

const routes = [
    {
        name: 'login',
        path: '/',
        component: () => import('@/views/LogIn'),
    },
    {
        name: 'collections',
        path: '/c',
        component: () => import('@/views/Collections'),
    },
    {
        name: 'collection',
        path: '/c/:collection_id',
        props: true,
        component: () => import('@/views/Collection'),
    },
    {
        name: '404',
        path: '/:pathMatch(.*)*',
        component: () => import('@/views/NotFound'),
    }
]

export const history = createWebHistory()

const router = createRouter({history, routes})

router.beforeEach((to) => {
    if (!store.state.auth.token && to.name !== 'login') {
        return {name: 'login'};
    }
})

export default router;
